// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";
import { Text, HStack } from "@chakra-ui/react";
import Icon from "src/icons";

import * as styles from "./styles";

type Props = {
  handleRemove: () => void
};

const RemoveSingleUser = ({ handleRemove }: Props) => {
  return (
    <HStack
      data-cy="removeSingleUser"
      sx={styles.RemoveUser}
      onClick={handleRemove}
    >
      <Text sx={styles.RemoveUserText}>{i18n.t(k.REMOVE_SELECTED_USER)}</Text>
      <Icon type="checklistRemove" style={styles.RemoveUserIcon} />
    </HStack>
  );
};

export default RemoveSingleUser;
